export const getDefaultCalendarName = (defaultCalendarName: string) => {
    if (!defaultCalendarName) {
        return 'Default';
    }

    return `Default (${defaultCalendarName})`;
};
